import {
  faAdd,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faEnvelope,
  faPen,
  faPhone,
  faUser,
  faX,
  faBuilding,
  faArrowRotateForward,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Container } from "@mui/system";
import { Grid, Skeleton } from "@mui/material";
import Modal from "../../components/b2b/Modal";
import { useEffect } from "react";
import CountryList from "country-list-with-dial-code-and-flag";
import { faSave, faSearch } from "@fortawesome/fontawesome-free-solid";
import Select from "react-select";
import { FileUploader } from "react-drag-drop-files";
import {
  setAffiliateNextPage,
  setAffiliatePreviousPage,
  setAffiliatePageNumber,
} from "../../redux/app/affiliate/affiliate-slice";
import { toast } from "react-toastify";
import LoadingIcon from "../../components/loading/LoadingIcon";

let addedRegions = [];

let affiliateEditObj = {};

const Affiliate = () => {
  const dispatch = useDispatch();
  const formData = new FormData();
  const [logo, setlogo] = useState();
  const { token } = useSelector((state) => state.auth);

  const handlePageInputChange = (e) => {
    const pageNumber = e.target.value ? parseInt(e.target.value, 10) : "";
    if (e.target.value === "") {
      dispatch(setAffiliatePageNumber(""));
      return;
    }
    if (pageNumber < 1 || pageNumber > totalPages) {
      toast("Enter A  Valid Page Number");
      return; // Don't dispatch if the input is invalid
    }

    dispatch(setAffiliatePageNumber(pageNumber));
  };

  const {
    affiliates,
    countryInput,
    countryCode,
    status,
    totalNumberOfAffiliates,
    affiliatePage,
    affiliateIsLoading,
    isAffiliaeCreating,
    currentPage,
    totalPages,
    affiliateError,
  } = useSelector((state) => state.affiliate);

  const { allRegionsOrSearch } = useSelector((state) => state.region);
  const [expanded, setExpanded] = React.useState(false);
  let addedRegions = [];

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const options = [];

  allRegionsOrSearch.forEach((region) => {
    options.push({ value: region._id, label: region.name });
  });

  const [showModal, setShowModal] = React.useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [affiliateNameSearch, setaffiliateNameSearch] = useState("");
  const [pageLimit, setPageLimit] = useState(20);

  const [affiliate, setAffiliate] = React.useState({
    affiliateNameInput: "",
    contactNameInput: "",
    addressInput: "",
    email1Input: "",
    email2Input: "",
    mobile1NumberInput: "",
    mobile2NumberInput: "",
    mobile3NumberInput: "",
    countryCode: "",
    cityInput: "",
    companyid: "",
    password: "",
  });

  const [affiliateEdit, setAffiliateEdit] = React.useState({
    affiliateNameInput: "",
    contactNameInput: "",
    addressInput: "",
    cityInput: "",
    countryInput: "",
    email1Input: "",
    email2Input: "",
    mobile1NumberInput: "",
    mobile2NumberInput: "",
    mobile3NumberInput: "",
    statusInput: "",
    companyid: "",
    countryCode: "",
  });

  const [affiliateNameInput, setaffiliateNameInput] = useState();
  const [contactNameInput, setcontactNameInput] = useState();
  const [addressInput, setaddressInput] = useState();
  const [cityInput, setcityInput] = useState();
  const [countryInputA, setcountryInputA] = useState();
  const [countryCodeEdited, setcountryCodeEdited] = useState();
  const [email1Input, setemail1Input] = useState();
  const [email2Input, setemail2Input] = useState();
  const [mobile1NumberInput, setmobile1NumberInput] = useState();
  const [mobile2NumberInput, setmobile2NumberInput] = useState();
  const [mobile3NumberInput, setmobile3NumberInput] = useState();
  const [statusInput, setstatusInput] = useState();

  const [openCOuntryCode, setOpenCOuntryCode] = useState(false);

  const addAffiliateHandler = () => {
    if (
      affiliate.affiliateNameInput === "" ||
      affiliate.contactNameInput === "" ||
      affiliate.addressInput === "" ||
      affiliate.country === "" ||
      affiliate.cityInput === "" ||
      countryInput === "" ||
      countryCode === "" ||
      affiliate.email1Input === "" ||
      // affiliate.email2Input === "" ||
      affiliate.mobile1NumberInput === "" ||
      status === ""
    ) {
      toast.warn("All fields are required!");
    } else if (affiliate.companyid === "" || affiliate.password === "") {
      toast.warn("Company id and password is mandatory");
    } else {
      const affiliatePayload = {
        affiliateName: affiliate.affiliateNameInput,
        contactPerson: affiliate.contactNameInput,
        address: affiliate.addressInput,
        country: countryInput,
        city: affiliate.cityInput,
        countryCode: countryCode,
        email1: affiliate.email1Input,
        email2: affiliate.email2Input,
        phone1: affiliate.mobile1NumberInput,
        phone2: affiliate.mobile2NumberInput,
        phone3: affiliate.mobile3NumberInput,
        status: status && status,
        regions: addedRegions,
        companyid: affiliate.companyid,
        password: affiliate.password,
      };

      dispatch({
        type: "CREATE_AFFILIATE",
        payload: { affiliate: affiliatePayload, token },
      });
      setShowModal(false);
      setAffiliate({
        affiliateNameInput: "",
        contactNameInput: "",
        addressInput: "",
        email1Input: "",
        email2Input: "",
        mobile1NumberInput: "",
        mobile2NumberInput: "",
        mobile3NumberInput: "",
        countryCode: "",
        cityInput: "",
        companyid: "",
        password: "",
      });
    }
  };

  useEffect(() => {
    dispatch({
      type: "GET_ALL_AFFILIATES",
      payload: {
        token,
        page: currentPage,
        limit: pageLimit,
        search: affiliateNameSearch,
      },
    });
    dispatch({
      type: "GET_ALL_REGION_OR_SEARCH",
    });
    dispatch({
      type: "TOTAL_NUMBER_OF_AFFILIATES",
      payload: token,
    });
  }, [currentPage, token, affiliateNameSearch]);

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);

  const handleSearchByName = (e) => {
    e.preventDefault();
    if (affiliateNameSearch !== "") {
      dispatch({
        type: "GET_ALL_AFFILIATES",
        payload: { token, page: currentPage, limit: pageLimit },
      });
      setaffiliateNameSearch("");
    }
  };

  return (
    <div className="fixed w-screen h-screen ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen h-screen">
          <div className="sm:flex items-center justify-between sm:justify-start lg:justify-start px-3 shadow-md pb-3 sm:pb-0">
            {/* <div hidden>
              <div className="flex space-x-5">
                <div className="px-0 py-5 text-xl xl:px-10 font-semibold text-primary">
                  Affiliate
                </div>
                <div className="flex items-center space-x-2">
                  <div className="text-sm">No of affiliates :</div>
                  <div className="text-2xl font-semibold text-primary">
                    {totalNumberOfAffiliates}
                  </div>
                </div>
              </div>

              <button
                className="items-center block px-2 py-1 space-x-2 tracking-wider text-white rounded-sm cursor-pointer bg-primary hover:bg-red-600 hover:shadow-md"
                type="button"
                onClick={() => setShowModal(true)}
              >
                <FontAwesomeIcon icon={faAdd} className="w-5" />
                Add Affiliate
              </button>
            </div> */}

            <div className="lg:flex lg:space-x-5">
              <div className="flex space-x-3 ">
                {/* <div className="px-0 py-5 text-lg xl:text-xl xl:px-10 font-semibold text-primary">
                  Affiliate
                </div> */}
                {/*  */}
                <div className="flex items-center space-x-1">
                  <div className="text-base font-body">No of affiliates:</div>
                  <div className="text-xl font-semibold text-primary font-body">
                    {totalNumberOfAffiliates}
                  </div>
                </div>
              </div>

              <form className="flex space-x-5 pb-3 md:mt-3">
                <div className="w-full grow">
                  <div className="text-xs font-body">Affiliate Name</div>
                  <input
                    value={affiliateNameSearch}
                    onChange={(e) => {
                      setaffiliateNameSearch(e.target.value);
                    }}
                    type="text"
                    placeholder="Search"
                    className="border-b focus:outline-none textField text-sm sm:text-base font-body"
                  />
                </div>
                <div
                  onClick={(e) => {
                    if (affiliateNameSearch !== "") {
                      handleSearchByName(e);
                    }
                  }}
                  className={`${
                    affiliateNameSearch === ""
                      ? "bg-gray-300 text-black"
                      : "bg-secondary text-white"
                  } flex items-center content-end justify-end space-x-2 cursor-pointer  h-8 px-3 rounded-md`}
                >
                  <FontAwesomeIcon
                    icon={faArrowRotateForward}
                    className="w-4 h-4"
                  />
                  <div className="text-base font-body">Reset</div>
                </div>
              </form>
            </div>
            <div className="">
              {isAffiliaeCreating && (
                <div className="">
                  <LoadingIcon />
                </div>
              )}
            </div>
            <div className="sm:mt-1.5 sm:ml-3 md:mt-4 lg:-mt-2">
              <button
                className="items-center block px-2 h-8 space-x-2 tracking-wider text-white rounded-md cursor-pointer lg:mr-20 xl:mr-3 bg-secondary hover:bg-gray-300 hover:text-black lg:text-sm lg font-body"
                type="button"
                onClick={() => setShowModal(true)}
              >
                <FontAwesomeIcon icon={faAdd} className="w-5" />
                Add Affiliate
              </button>

              {/* Start of Main modal */}

              {showModal ? (
                <>
                  <Modal
                    heading="Add Affiliate"
                    addOnClick={addAffiliateHandler}
                    cancelOnClick={() => {
                      setShowModal(false);
                    }}
                    addButtonLabel="Add Affiliate"
                    isAffiliate={true}
                    companyaffiliateIdNameInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        companyid: e.target.value,
                      });
                    }}
                    companyaffiliatePasswordInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        password: e.target.value,
                      });
                    }}
                    affiliateNameInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        affiliateNameInput: e.target.value,
                      });
                    }}
                    contactNameInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        contactNameInput: e.target.value,
                      });
                    }}
                    // affiliateCity={affiliate?.cityInput}
                    setAffiliateCity={(e) => {
                      setAffiliate({
                        ...affiliate,
                        cityInput: e.target.value,
                      });
                    }}
                    addressInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        addressInput: e.target.value,
                      });
                    }}
                    email1Input={(e) => {
                      setAffiliate({
                        ...affiliate,
                        email1Input: e.target.value,
                      });
                    }}
                    email2Input={(e) => {
                      setAffiliate({
                        ...affiliate,
                        email2Input: e.target.value,
                      });
                    }}
                    mobile1NumberInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        mobile1NumberInput: e.target.value,
                      });
                    }}
                    mobile2NumberInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        mobile2NumberInput: e.target.value,
                      });
                    }}
                    mobile3NumberInput={(e) => {
                      setAffiliate({
                        ...affiliate,
                        mobile3NumberInput: e.target.value,
                      });
                    }}
                    afiliateRegionsAdd={(regions) => {
                      addedRegions = [];
                      regions?.map((region) => addedRegions.push(region.value));
                    }}
                    affliateGlobalCheck={(e) => {
                      if (e.target.checked) {
                        allRegionsOrSearch?.forEach((region) => {
                          addedRegions.push(region._id);
                        });
                      } else {
                        addedRegions = [];
                      }
                    }}
                  />
                  <div
                    className="fixed inset-0 z-40 bg-black opacity-25"
                    onClick={() => {
                      setShowModal(false);
                    }}
                  ></div>
                </>
              ) : null}
              {/* End of Main modal */}
            </div>
          </div>
          <div className="flex sm:justify-start lg:justify-end px-6 lg:px-10 pt-2 space-x-3 lg:mr-14">
            <div className="flex space-x-2 items-center font-body w-40">
              <h2>Page:</h2>
              <div className="w-12 border border-gray-300 rounded-md px-1.5 py-1 text-sm">
                <input
                  type="number"
                  className="text-gray-700"
                  value={currentPage}
                  onChange={handlePageInputChange}
                />
              </div>
              <div>/</div>
              <div>{totalPages}</div>
            </div>
            <div
              onClick={() => {
                if (currentPage > 1) {
                  dispatch(setAffiliatePreviousPage());
                }
              }}
              className={`flex items-center space-x-2 cursor-pointer ${
                currentPage === 1 ? "text-gray-400 cursor-not-allowed" : ""
              }`}
            >
              <FontAwesomeIcon icon={faArrowAltCircleLeft} />
              <div className="font-body">Prev</div>
            </div>

            <div
              // onClick={() => {
              //   dispatch(setAffiliateNextPage());
              // }}
              onClick={() => {
                if (totalPages && currentPage < totalPages) {
                  dispatch(setAffiliateNextPage());
                }
              }}
              className={`flex items-center space-x-2 cursor-pointer ${
                totalPages && currentPage === totalPages
                  ? "text-gray-400 cursor-not-allowed"
                  : ""
              }`}

              // className="flex items-center space-x-2 cursor-pointer"
            >
              <div className=" font-body">Next</div>
              <FontAwesomeIcon icon={faArrowAltCircleRight} />
            </div>
          </div>
          <div className="overflow-y-auto h-[75vh] scrollbar">
            {affiliateError ? (
              <>
                <div className="flex h-full justify-center items-center text-3xl text-slate-400">
                  {affiliateError}
                </div>
              </>
            ) : (
              <>
                {!affiliateIsLoading ? (
                  affiliates?.map((affiliate) => (
                    <div className="mx-3 my-2">
                      <Accordion
                        expanded={expanded === affiliate?._id}
                        onChange={handleChange(affiliate?._id)}
                        onClick={() => {
                          setAffiliateEdit({
                            affiliateNameInput: affiliate.affiliateName,
                            contactNameInput: affiliate.contactPerson,
                            addressInput: affiliate.address,
                            countryInput: affiliate.country,
                            cityInput: affiliate.city,
                            email1Input: affiliate.email1,
                            email2Input: affiliate.email2,
                            mobile1NumberInput: affiliate.phone1,
                            mobile2NumberInput: affiliate.phone2,
                            mobile3NumberInput: affiliate.phone3,
                            statusInput: affiliate.status,
                            companyid: affiliate.companyid,
                          });
                        }}
                      >
                        <AccordionSummary
                          className=" md:w-full"
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <div className="grid md:grid-cols-2 lg:grid-cols-4 space-y-2 md:space-y-0">
                            <div>
                              <Container className="flex items-center space-x-2 px-3.5 md:px-0">
                                <FontAwesomeIcon icon={faBuilding} />
                                <Typography
                                  sx={{ color: "text.text-black" }}
                                  className="font-body truncate max-w-[200px] lg:w-36 xl:w-52 2xl:w-64 2xl:max-w-[300px]"
                                >
                                  {affiliate?.affiliateName}
                                </Typography>
                              </Container>
                            </div>
                            <div className="flex  items-center space-x-2 pl-3.5 md:px-0">
                              <FontAwesomeIcon icon={faUser} />
                              <Typography
                                sx={{
                                  width: "20rem",
                                  maxWidth: "20rem",
                                  flexShrink: 0,
                                }}
                                className="font-body truncate max-w-[200px] lg:w-36 xl:w-52 2xl:w-64 2xl:max-w-[300px]"
                              >
                                {affiliate?.contactPerson}
                              </Typography>
                            </div>
                            <div className="lg:w-96">
                              <Container className="flex items-center space-x-2 md:px-0 px-3.5">
                                <FontAwesomeIcon icon={faEnvelope} />
                                <Typography
                                  sx={{ color: "text.text-black" }}
                                  className="font-body truncate max-w-[200px] lg:w-36 xl:w-52 2xl:w-64 2xl:max-w-[300px]"
                                >
                                  {affiliate?.email1}
                                </Typography>
                              </Container>
                            </div>
                            <div>
                              <Container className="flex items-center space-x-2 px-3.5 md:px-0">
                                <FontAwesomeIcon icon={faPhone} />
                                <Typography
                                  sx={{ color: "text.text-black" }}
                                  className=" font-body"
                                >
                                  {affiliate?.phone1}
                                </Typography>
                              </Container>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="bg-slate-50  border-slate-400 border-t-[1px]">
                          <div className="lg:flex justify-between">
                            <div className="">
                              <div className="text-xl text-black font-semibold mb-5 font-body">
                                User details
                              </div>
                              <div className="pb-5 mt-2 space-y-2">
                                <div className="flex items-center space-x-2">
                                  <div className="w-32 font-bold text-sm font-body">
                                    Affiliate Name:
                                  </div>
                                  {!isEdit ? (
                                    <div className="font-normal text-sm font-body">
                                      {affiliate?.affiliateName}
                                    </div>
                                  ) : (
                                    <div className="text-sm font-normal font-body">
                                      <input
                                        className="textField"
                                        value={
                                          affiliateEditObj?.affiliateNameInput
                                            ? affiliateEditObj?.affiliateNameInput
                                            : affiliateEdit.affiliateNameInput
                                        }
                                        onChange={(e) => {
                                          affiliateEditObj.affiliateNameInput =
                                            e.target.value;
                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            affiliateNameInput: e.target.value,
                                          });
                                          setaffiliateNameInput(e.target.value);
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="flex items-center space-x-2">
                                  <div className="w-32 font-bold text-sm font-body">
                                    Contact Person:
                                  </div>
                                  {!isEdit ? (
                                    <div className="text-sm font-normal font-body">
                                      {affiliate?.contactPerson}
                                    </div>
                                  ) : (
                                    <div className="text-sm font-normal font-body">
                                      <input
                                        className="textField"
                                        type="text"
                                        value={
                                          affiliateEditObj?.contactNameInput
                                            ? affiliateEditObj?.contactNameInput
                                            : affiliateEdit.contactNameInput
                                        }
                                        onChange={(e) => {
                                          affiliateEditObj.contactNameInput =
                                            e.target.value;
                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            contactNameInput: e.target.value,
                                          });
                                          setcontactNameInput(e.target.value);
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="flex items-center space-x-2">
                                  <div className="w-32 text-sm font-bold font-body">
                                    Address:
                                  </div>
                                  {!isEdit ? (
                                    <div className="text-sm font-normal font-body">
                                      {affiliate?.address}
                                    </div>
                                  ) : (
                                    <div className="text-sm font-normal font-body">
                                      <input
                                        className="textField"
                                        value={
                                          affiliateEditObj?.addressInput
                                            ? affiliateEditObj?.addressInput
                                            : affiliateEdit.addressInput
                                        }
                                        onChange={(e) => {
                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            addressInput: e.target.value,
                                          });
                                          setaddressInput(e.target.value);
                                          affiliateEditObj.addressInput =
                                            e.target.value;
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="flex items-center space-x-2">
                                  <div className="w-32 text-sm font-bold font-body">
                                    Country:
                                  </div>
                                  {!isEdit ? (
                                    <div className="text-sm font-normal font-body">
                                      {affiliate?.country}
                                    </div>
                                  ) : (
                                    <div>
                                      <input
                                        className="textField"
                                        value={
                                          affiliateEditObj?.countryInput
                                            ? affiliateEditObj?.countryInput
                                            : affiliateEdit.countryInput
                                        }
                                        onChange={(e) => {
                                          affiliateEditObj.countryInput =
                                            e.target.value;
                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            countryInput: e.target.value,
                                          });
                                          setcountryInputA(e.target.value);
                                        }}
                                        onFocus={() => {
                                          setOpenCOuntryCode(true);
                                        }}
                                      />
                                      {openCOuntryCode && (
                                        <div className="absolute mx-1 overflow-y-auto translate-y-2 bg-white border shadow-2xl translate-x-52 w-52 h-60 scrollbar rounded-bl-md rounded-br-md bottom-2">
                                          {CountryList?.map(
                                            (country) =>
                                              country.name
                                                .toLowerCase()
                                                .includes(
                                                  affiliateEdit.countryInput.toLowerCase()
                                                ) && (
                                                <div
                                                  onClick={(e) => {
                                                    affiliateEditObj.countryInput =
                                                      country?.name;
                                                    affiliateEditObj.countryCode =
                                                      country?.dial_code;
                                                    setcountryCodeEdited(
                                                      country?.dial_code
                                                    );
                                                    // setAffiliateEdit({
                                                    //     ...affiliateEdit,
                                                    //   countryInput:country?.name,
                                                    //   countryCode:country?.dial_code
                                                    //  });
                                                    setcountryInputA(
                                                      country?.name
                                                    );
                                                    setOpenCOuntryCode(false);
                                                  }}
                                                  className="flex items-center justify-between px-3 space-y-2 text-sm cursor-pointer hover:bg-primary hover:text-white"
                                                >
                                                  <div>{country.name}</div>
                                                  <div>{country.dial_code}</div>
                                                </div>
                                              )
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                                <div className="flex items-center space-x-2">
                                  <div className="w-32 text-sm font-bold font-body">
                                    City
                                  </div>
                                  {!isEdit ? (
                                    <div className="text-sm font-normal font-body">
                                      {affiliate?.city}
                                    </div>
                                  ) : (
                                    <div className="text-sm font-normal font-body">
                                      <input
                                        className="textField"
                                        value={
                                          affiliateEditObj?.cityInput
                                            ? affiliateEditObj?.cityInput
                                            : affiliateEdit.cityInput
                                        }
                                        // onChange={(e) => {
                                        //   setAffiliateEdit({
                                        //     ...affiliateEdit,
                                        //     cityInput: e.target.value,
                                        //   });
                                        //   setcityInput(e.target.value);
                                        //   affiliateEditObj.cityInput =
                                        //     e.target.value;
                                        // }}

                                        onChange={(e) => {
                                          affiliateEditObj.cityInput =
                                            e.target.value;
                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            cityInput: e.target.value,
                                          });
                                          setcityInput(e.target.value);
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* contact Details */}

                            <div className="border-slate-400 border-y-[1px] py-5 my-5 lg:border-y-0 lg:py-0 lg:my-0 lg:border-x-[1px] lg:px-3 xl:px-5">
                              <div className="text-xl text-black font-semibold mb-5 font-body">
                                Contact details
                              </div>

                              <div className="tracking-wider ">
                                <div className="flex">
                                  <div className="w-36 text-sm font-semibold text-black font-body">
                                    Email ID:
                                  </div>
                                  <div className="space-y-2">
                                    {!isEdit ? (
                                      <div className="text-sm font-body">
                                        {affiliate?.email1}
                                      </div>
                                    ) : (
                                      <div className="text-sm font-body">
                                        <input
                                          className="textField"
                                          value={
                                            affiliateEditObj?.email1Input
                                              ? affiliateEditObj?.email1Input
                                              : affiliateEdit.email1Input
                                          }
                                          onChange={(e) => {
                                            affiliateEditObj.email1Input =
                                              e.target.value;
                                            setAffiliateEdit({
                                              ...affiliateEdit,
                                              email1Input: e.target.value,
                                            });
                                            setemail1Input(e.target.value);
                                          }}
                                        />
                                      </div>
                                    )}
                                    {!isEdit ? (
                                      <div className="text-sm font-body">
                                        {affiliate?.email2}
                                      </div>
                                    ) : (
                                      <div className="text-sm font-body">
                                        <input
                                          className="textField"
                                          value={
                                            affiliateEditObj?.email2Input
                                              ? affiliateEditObj?.email2Input
                                              : affiliateEdit.email2Input
                                          }
                                          onChange={(e) => {
                                            affiliateEditObj.email2Input =
                                              e.target.value;
                                            setAffiliateEdit({
                                              ...affiliateEdit,
                                              email2Input: e.target.value,
                                            });
                                            setemail2Input(e.target.value);
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="flex mt-6">
                                  <div className="w-36 text-sm font-semibold text-black font-body">
                                    Contact Number:
                                  </div>
                                  <div className="space-y-2">
                                    {!isEdit ? (
                                      <div className="text-sm font-body">
                                        {affiliate?.phone1}
                                      </div>
                                    ) : (
                                      <div className="text-sm font-body">
                                        <input
                                          className="textField"
                                          value={
                                            affiliateEditObj?.phone1Input
                                              ? affiliateEditObj?.phone1Input
                                              : affiliateEdit.mobile1NumberInput
                                          }
                                          onChange={(e) => {
                                            affiliateEditObj.phone1Input =
                                              e.target.value;
                                            setAffiliateEdit({
                                              ...affiliateEdit,
                                              mobile1NumberInput:
                                                e.target.value,
                                            });
                                            setmobile1NumberInput(
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    )}
                                    {!isEdit ? (
                                      <div className="text-sm font-body">
                                        {affiliate?.phone2}
                                      </div>
                                    ) : (
                                      <div className="text-sm font-body">
                                        <input
                                          className="textField"
                                          value={
                                            affiliateEditObj?.phone2Input
                                              ? affiliateEditObj?.phone2Input
                                              : affiliateEdit.mobile2NumberInput
                                          }
                                          onChange={(e) => {
                                            affiliateEditObj.phone2Input =
                                              e.target.value;
                                            setAffiliateEdit({
                                              ...affiliateEdit,
                                              mobile2NumberInput:
                                                e.target.value,
                                            });
                                            setmobile2NumberInput(
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    )}
                                    {!isEdit ? (
                                      <div className="text-sm font-body">
                                        {affiliate?.phone3}
                                      </div>
                                    ) : (
                                      <div className="text-sm font-body">
                                        <input
                                          className="textField"
                                          value={
                                            affiliateEditObj?.phone3Input
                                              ? affiliateEditObj?.phone3Input
                                              : affiliateEdit.mobile3NumberInput
                                          }
                                          onChange={(e) => {
                                            affiliateEditObj.phone3Input =
                                              e.target.value;
                                            setAffiliateEdit({
                                              ...affiliateEdit,
                                              mobile3NumberInput:
                                                e.target.value,
                                            });
                                            setmobile3NumberInput(
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="flex items-center mt-5">
                                  <h2 className="w-36 text-sm font-semibold text-black font-body">
                                    Company ID:
                                  </h2>
                                  {!isEdit ? (
                                    <h2 className="text-sm font-body">
                                      {" "}
                                      {affiliate?.companyid}
                                    </h2>
                                  ) : (
                                    <div className="text-sm font-body">
                                      <input
                                        className="textField"
                                        value={
                                          affiliateEditObj?.companyid
                                            ? affiliateEditObj?.companyid
                                            : affiliateEdit.companyid
                                        }
                                        onChange={(e) => {
                                          affiliateEditObj.companyid =
                                            e.target.value;
                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            companyid: e.target.value,
                                          });
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="flex items-center mt-5">
                                  {isEdit && (
                                    <h2 className="w-36 text-sm font-semibold text-black font-body">
                                      Password:
                                    </h2>
                                  )}
                                  {isEdit && (
                                    <div className="text-sm font-body">
                                      <input
                                        className="textField"
                                        onChange={(e) => {
                                          affiliateEditObj.password =
                                            e.target.value;
                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            password: e.target.value,
                                          });
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="pr-10 px-5">
                              <div className="space-y-3">
                                <div className="pt-10">
                                  <h2 className="mb-2">
                                    {isEdit ? " Upload Logo" : "Logo"}
                                  </h2>

                                  {isEdit ? (
                                    <input
                                      onChange={(e) => {
                                        setlogo(e.target.files[0]);
                                      }}
                                      type="file"
                                      accept="image/png, image/gif, image/jpeg,image/jpg "
                                    />
                                  ) : (
                                    <img
                                      src={affiliate?.logo?.secure_url}
                                      alt=""
                                      className="w-52 h-auto"
                                    />
                                  )}
                                </div>
                                {/* <div className="text-lg text-black font-semibold">
                            Regions
                          </div> */}
                                {/* <div className="flex space-x-1">
                            <div className="text-sm font-semibold">
                              Regions:
                            </div>
                            {!isEdit ? (
                              <div className="">
                                {affiliate?.regions &&
                                affiliate?.regions.length < 5
                                  ? affiliate?.regions.map((region) => (
                                      <div className="text-sm font-normal">
                                        {region?.name}
                                      </div>
                                    ))
                                  : affiliate?.regions.length > 5 &&
                                    affiliate?.regions
                                      .slice(0, 6)
                                      .map((region) => (
                                        <div className="text-sm font-normal">
                                          {region?.name}
                                        </div>
                                      ))}{" "}
                                {affiliate?.regions.length > 5 && (
                                  <div className="flex space-x-1 items-center font-semibold">
                                    <div className="text-sm ">
                                      + {affiliate?.regions.length - 5}
                                    </div>
                                    <div className="text-sm text-gray-600">
                                      more
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div>
                                <Select
                                  defaultValue={affiliate?.regions.map(
                                    (region) => {
                                      return {
                                        label: region.name,
                                        value: region._id,
                                      };
                                    }
                                  )}
                                  options={options}
                                  isMulti
                                  onChange={(selectedregions) => {
                                    affiliateEditObj = {
                                      ...affiliateEditObj,
                                      regions: [],
                                    };
                                    selectedregions.map((region) =>
                                      affiliateEditObj?.regions.push(
                                        region.value
                                      )
                                    );
                                    
                                  }}
                                />
                              </div>
                            )}
                          </div> */}
                                <div className="flex space-x-1 items-center">
                                  <div className="text-sm font-semibold text-black font-body">
                                    Status:
                                  </div>
                                  {!isEdit ? (
                                    <div className="text-sm text-green-600 font-semibold font-body">
                                      {affiliate?.status}
                                    </div>
                                  ) : (
                                    <div>
                                      {/* <Select
                                    options={[
                                      { value: "NONE", label: "None" },
                                      { value: "ACTIVE", label: "Active" },
                                      { value: "INACTIVE", label: "Inactive" },
                                    ]}
                                    onChange={(e) => {
                                      // dispatch(setStatus({ status: e.value }));
                                      affiliateEditObj.statusInput = e.value;
                                      
                                      setAffiliateEdit({
                                        ...affiliateEdit,
                                        statusInput: e.value,
                                      });
                                    }}
                                  /> */}
                                      <select
                                        className="h-10 border border-gray-300 rounded-md w-33 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                                        onClick={(e) => {
                                          // dispatch(setStatus({ status: e.target.value }));

                                          affiliateEditObj.statusInput =
                                            e.target.value;

                                          setAffiliateEdit({
                                            ...affiliateEdit,
                                            statusInput: e.target.value,
                                          });
                                          setstatusInput(e.target.value);
                                        }}
                                      >
                                        <option value="">None</option>
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">
                                          {" "}
                                          Inactive
                                        </option>
                                      </select>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {!isEdit ? (
                            <div
                              onClick={() => {
                                setIsEdit(true);
                                // const affiliatePayloadUpdated = {
                                //   affiliateName:
                                //     affiliateEditObj?.affiliateNameInput,
                                //   contactPerson:
                                //     affiliateEditObj?.contactNameInput,
                                //   address: affiliateEditObj?.addressInput,
                                //   country: affiliateEditObj?.countryInput,
                                //   email1: affiliateEditObj?.email1Input,
                                //   email2: affiliateEditObj?.email2Input,
                                //   phone1: affiliateEditObj?.phone1Input,
                                //   phone2: affiliateEditObj?.phone2Input,
                                //   phone3: affiliateEditObj?.phone3Input,
                                //   status: affiliateEditObj?.statusInput,
                                //   regions: affiliateEditObj?.regions,
                                // };

                                affiliateEditObj = {
                                  affiliateNameInput: affiliate.affiliateName,
                                  contactNameInput: affiliate.contactPerson,
                                  addressInput: affiliate.address,
                                  countryInput: affiliate.country,
                                  countryCode: affiliate?.countryCode,
                                  cityInput: affiliate.city,
                                  email1Input: affiliate.email1,
                                  email2Input: affiliate.email2,
                                  mobile1NumberInput: affiliate.phone1,
                                  mobile2NumberInput: affiliate.phone2,
                                  mobile3NumberInput: affiliate.phone3,
                                  statusInput: affiliate.status,
                                  companyid: affiliate.companyid,
                                };

                                setaffiliateNameInput(affiliate.affiliateName);
                                setcontactNameInput(affiliate.contactPerson);
                                setaddressInput(affiliate.address);
                                setcityInput(affiliate.city);
                                setcountryInputA(affiliate.country);
                                setemail1Input(affiliate.email1);
                                setemail2Input(affiliate.email2);
                                setmobile1NumberInput(affiliate.phone1);
                                setmobile2NumberInput(affiliate.phone2);
                                setmobile3NumberInput(affiliate.phone3);
                                setstatusInput(affiliate.status);
                              }}
                              className="flex items-center content-end justify-end px-3 h-8 mt-3 space-x-2 text-white rounded-sm cursor-pointer bg-secondary hover:bg-gray-300 hover:text-black min-w-min w-min"
                            >
                              <FontAwesomeIcon
                                icon={faPen}
                                className="w-4 h-4"
                              />
                              <div className="text-base font-body">Edit</div>
                            </div>
                          ) : (
                            <div className="flex items-center pt-2 space-x-3">
                              <div
                                onClick={() => {
                                  setIsEdit(false);
                                  affiliateEditObj = {};
                                }}
                                className="flex items-center content-end justify-end sm:px-2 py-1 space-x-2 rounded-md cursor-pointer text-primary min-w-min w-min"
                              >
                                <FontAwesomeIcon
                                  icon={faX}
                                  className="w-4 h-4"
                                />
                                <div className="text-base font-body">
                                  Cancel
                                </div>
                              </div>
                              <div
                                onClick={() => {
                                  formData.append("logo", logo);
                                  formData.append(
                                    "affiliateName",
                                    affiliateNameInput
                                  );
                                  formData.append(
                                    "contactPerson",
                                    contactNameInput
                                  );
                                  formData.append("address", addressInput);
                                  formData.append("country", countryInputA);
                                  formData.append(
                                    "countryCode",
                                    countryCodeEdited
                                  );
                                  formData.append("city", cityInput);
                                  formData.append("email1", email1Input);
                                  formData.append("email2", email2Input);
                                  formData.append("phone1", mobile1NumberInput);
                                  formData.append("phone2", mobile2NumberInput);
                                  formData.append("phone3", mobile3NumberInput);
                                  formData.append("status", statusInput);
                                  formData.append(
                                    "companyid",
                                    affiliateEdit.companyid
                                  );
                                  formData.append(
                                    "password",
                                    affiliateEdit.password
                                  );

                                  // const affiliatePayloadUpdated = {
                                  //   affiliateName:
                                  //     affiliateEditObj?.affiliateNameInput,
                                  //   contactPerson:
                                  //     affiliateEditObj?.contactNameInput,
                                  //   address: affiliateEditObj?.addressInput,
                                  //   country: affiliateEditObj?.countryInput,
                                  //   email1: affiliateEditObj?.email1Input,
                                  //   email2: affiliateEditObj?.email2Input,
                                  //   phone1: affiliateEditObj?.phone1Input,
                                  //   phone2: affiliateEditObj?.phone2Input,
                                  //   phone3: affiliateEditObj?.phone3Input,
                                  //   status: affiliateEditObj?.statusInput,
                                  //   regions: affiliateEditObj?.regions,
                                  // };
                                  dispatch({
                                    type: "UPDATE_AFFILIATE",
                                    payload: {
                                      affiliateUpdateBody: formData,
                                      affiliateId: affiliate._id,
                                      token: token,
                                    },
                                  });
                                  setIsEdit(false);
                                  affiliateEditObj = {};
                                }}
                                className="flex items-center content-end justify-end px-3 h-8 space-x-2 text-white rounded-sm cursor-pointer bg-secondary hover:bg-gray-300 hover:text-black min-w-min w-min"
                              >
                                <FontAwesomeIcon
                                  icon={faSave}
                                  className="w-4 h-4"
                                />
                                <div className="text-base font-body">Save</div>
                              </div>
                            </div>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="px-10">
                      <Skeleton animation="wave" height={100} />
                      <Skeleton animation="wave" height={100} />
                      <Skeleton animation="wave" height={100} />
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Affiliate);

const fileTypes = ["JPG", "PNG", "GIF"];

export const DragDrop = () => {
  const [file, setFile] = useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  return (
    <FileUploader handleChange={handleChange} name="file" types={fileTypes} />
  );
};
